import { PurchaseOrderEditFormik } from '../PurchaseOrderEditFormik';
import { PurchaseOrderGetMinDto } from '../PurchaseOrderGetMinDto';

export const purchaseOrderGetMinToFormik = (item: PurchaseOrderGetMinDto): PurchaseOrderEditFormik => {
  const formik: PurchaseOrderEditFormik = {
    supplierId: item?.supplierId,
    palletId: item?.palletId,
    containerId: item?.containerId,
    shippingType: item?.shippingType,
    palletMaxWidth: item?.palletMaxWidth ? item?.palletMaxWidth.toString() : '',
    palletMaxHeight: item?.palletMaxHeight ? item.palletMaxHeight.toString() : '',
    palletMaxLength: item?.palletMaxLength ? item.palletMaxLength.toString() : '',
    maxKg: item?.maxKg ? item.maxKg.toString() : '',
    pickUpAddress: item?.pickUpAddress,
    palletsDescription: item?.palletsDescription,
    dateAvailable: item?.dateAvailable,
    grossWeightKg: item?.grossWeightKg,
    warehouseOwnerId: item?.warehouseOwnerId,
    warehousesIds: item?.warehousesIds,
    warehouses: item?.warehouses,
  };

  return formik;
}